module.exports = __webpack_public_path__ + "img/ios_3.9911280d.png";